export default __webpack_public_path__ + "static/media/Error.f8f546eb.jpg";